const getSocketUrl = () => {
  const apiDomain = process.env.REACT_APP_API_DOMAIN
  if (!apiDomain) return undefined

  try {
    return new URL(apiDomain).origin
  } catch (err) {
    return apiDomain.replace(/\/api\/?$/, '')
  }
}

export default getSocketUrl
